<template>
  <Layout>
    <h1 class="h1">Account &amp; Betaling</h1>
    <div class="my-6 max-w-2xl">
      <div class="mb-8">
        <h3 class="font-semibold py-3">Overeenkomst</h3>
        <div class="flex mb-2">
          <div class="w-20 text-gray-500">Account</div>
          <div>{{ account.name }}</div>
        </div>
        <div class="flex mb-2">
          <div class="w-20 text-gray-500">Pakket</div>
          <div v-if="subscription">
            <SubscriptionEventList :account="account" :subscription="subscription" />
          </div>
          <div v-else>
            {{ licenses == 1 ? '1 licentie' : `${licenses} licenties` }}
            (proefperiode tot {{ account.trial_ends_at | formatDay('D MMMM') }})
          </div>
        </div>
        <div class="flex mb-2" v-if="subscription">
          <div class="w-20 text-gray-500">Bedrag</div>
          <div
            v-if="isCancelled"
          >Account opgezegd per {{ subscription.cancel_at | formatDay('D MMMM') }}</div>
          <div v-else>
            {{ subscription.monthly_fee.total | formatMoney }} per maand (incl. BTW).
            <span>Volgende incasso op {{ subscription.next_invoice_at | formatDay('D MMMM') }}</span>
          </div>
        </div>
        <div v-if="!isCancelled" class="flex mt-3">
          <ModalButton
            v-if="subscription"
            class="btn btn-blue border mr-2"
            label="Wijzig licenties"
            size="max-w-md"
          >
            <h3 class="text-gray-400 my-2">Wijzig licenties</h3>
            <SubscriptionForm
              method="patch"
              action="/json/account/subscription"
              hide="details"
              :subscription="subscription"
              @success="success"
            />
          </ModalButton>
          <ModalButton
            v-else
            class="btn btn-blue mr-2"
            label="Start betaald account"
            size="max-w-4xl"
          >
            <h3 class="text-gray-400 my-2">Start betaald account</h3>
            <SubscriptionForm
              button-text="Start abonnement"
              action="/json/account/subscription"
              @redirect="redirect"
              show-start-comment
            />
          </ModalButton>
          <DeleteConfirmButton
            class="btn btn-red border border-gray-300 bg-white text-red-600"
            message="Weet je zeker dat je het account wilt opzeggen?"
            confirm-text="Ja, opzeggen"
            @confirm="cancelAccount"
          >Account opzeggen</DeleteConfirmButton>
        </div>
      </div>
      <div class="mb-8">
        <h3 class="font-semibold py-3">Verwerkersovereenkomst</h3>
        <div
          class="mb-3"
        >Verwerkersovereenkomst met {{ account.name }} geaccordeerd door {{ account.created_by.name_short }} op {{ account.created_at | formatDay }}</div>
        <div>
          <a
            href="/processor-agreement"
            class="btn btn-gray inline-block border bg-white"
          >Download document</a>
        </div>
      </div>
      <div class="mb-8">
        <h3 class="font-semibold py-3">Factuuradres</h3>
        <div v-if="subscription">
          <div class="flex mb-2">
            <div class="w-20 text-gray-500">Naam</div>
            <div>{{ subscription.name }}</div>
          </div>
          <div class="flex mb-3">
            <div class="w-20 text-gray-500">Adres</div>
            <div>
              <div>{{ subscription.address_line_1 }}</div>
              <div>{{ subscription.address_line_2 }}</div>
            </div>
          </div>
          <div v-if="!isCancelled">
            <ModalButton
              class="btn btn-gray bg-white border"
              label="Wijzig factuuradres"
              size="max-w-lg"
            >
              <h3 class="text-gray-400 my-2">Wijzig factuuradres</h3>
              <SubscriptionForm
                method="patch"
                action="/json/account/subscription"
                hide="licenses"
                :subscription="subscription"
                @success="success"
              />
            </ModalButton>
          </div>
        </div>
        <div v-else>
          <div class="text-gray-500">Nog geen factuuradres</div>
        </div>
      </div>
      <div class="mb-8">
        <h3 class="font-semibold py-3">Facturen</h3>
        <InvoiceList :invoices="account.invoices" />
      </div>
    </div>
  </Layout>
</template>

<script>
import { get, destroy } from "@/api.js";
import SubscriptionForm from "@/components/SubscriptionForm";
import SubscriptionEventList from "@/components/SubscriptionEventList";
import InvoiceList from "@/components/InvoiceList";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";

export default {
  components: {
    SubscriptionForm,
    SubscriptionEventList,
    InvoiceList,
    DeleteConfirmButton
  },

  metaInfo() {
    return { title: "Account" };
  },

  data() {
    return {
      account: {
        created_by: {},
        trial_ends_at: ""
      }
    };
  },

  beforeRouteEnter(to, from, next) {
    get(`/account`).then(response => next(vm => (vm.account = response.data)));
  },

  computed: {
    subscription() {
      return this.account.subscription;
    },

    licenses() {
      if (this.subscription) return this.subscription.licenses;

      return this.$store.state.settings.users.length;
    },

    isCancelled() {
      return this.subscription && this.subscription.cancel_at;
    }
  },

  methods: {
    redirect(redirectUrl) {
      window.location.replace(redirectUrl);
    },

    success(data) {
      this.account = data;
    },

    cancelAccount() {
      destroy("account").then(response => {
        this.account = response.data;

        this.$store.commit("FLASH_ADD", {
          message: "Account is opgezegd!",
          type: "warning"
        });

        if (!this.account.is_active) {
          this.$router.push({ name: "login" });
        }
      });
    }
  }
};
</script>
